import * as React from 'react';

interface Props {
  children: NonNullable<React.ReactNode>;
}

interface State {
  dropZoneActive: boolean;
}

export const DropZoneContext = React.createContext(false);

export class DropZoneProvider extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      dropZoneActive: false,
    };
  }

  componentDidMount() {
    document.addEventListener('dragover', this.handleDragOver, true);
    document.addEventListener('dragleave', this.handleDragLeave, true);
    document.addEventListener('drop', this.handleDrop, true);
  }

  componentWillUnmount() {
    document.removeEventListener('dragover', this.handleDragOver, true);
    document.removeEventListener('dragleave', this.handleDragLeave, true);
    document.removeEventListener('drop', this.handleDrop, true);
  }

  private handleDragOver = () => {
    this.setState({ dropZoneActive: true });
  };

  private handleDragLeave = () => {
    this.setState({ dropZoneActive: false });
  };

  private handleDrop = () => {
    this.setState({ dropZoneActive: false });
  };

  render() {
    return (
      <DropZoneContext.Provider value={this.state.dropZoneActive}>
        {this.props.children}
      </DropZoneContext.Provider>
    );
  }
}
